import { FeedbackModalType } from './types';

import CorrespondenceModalLoadable from './modals/CorrespondenceModal';

export const feedbackModalRenderer = (
  modalType: string,
  requestClose: () => void,
  params?: any
) => {
  switch (modalType) {
    case FeedbackModalType.CORRESPONDENCE:
      return (
        <CorrespondenceModalLoadable
          requestClose={requestClose}
          messageId={params.messageId}
          streamId={params.streamId}
        />
      );

    default:
      return;
  }
};

export default feedbackModalRenderer;
